import { apiRequest } from './client';

export function uploadTrackingIds(token, rows, { overrideExisting = false, dryRun = false } = {}) {
  return apiRequest('/admin/upload-tracking', token, {
    method: 'POST',
    body: JSON.stringify({ rows, overrideExisting, dryRun }),
  });
}
